<template>
  <div :class="{ 'div-padd': addPadding }">
    <canvas
      ref="canvas"
      style="width: 100%; height: auto; min-width: 20vw"
    ></canvas>
  </div>
</template>

<script>
export default {
  props: ["page", "mask", "clearStart", "addPadding"],
  async created() {
    // await new Promise((res, rej) => {
    //   let t = setInterval(() => {
    //     this.canvas = this.$refs.canvas;
    //     if (this.canvas) res(clearInterval(t));
    //   }, 1);
    // });
    this.$nextTick(() => {
      this.canvas = this.$refs.canvas;
      this.drawCanvas();
      this.$emit("loaded");
    });
  },
  methods: {
    drawCanvas() {
      const page = this.page;
      const orgImgSize = {
        w: page.img.picture.width,
        h: page.img.picture.height,
      };

      const yMinus = this.clearStart
        ? Object.values(page.columns)[0].marks[0].y * orgImgSize.h
        : 0;

      /** @type HTMLCanvasElement */
      const canvas = this.$refs.canvas;
      const ctx = canvas.getContext("2d");
      canvas.width = page.img.picture.width;
      canvas.height = page.img.picture.height - yMinus;

      const pxr = window.devicePixelRatio;
      // let destH = 1024;
      let destW = canvas.clientWidth;
      let destH = (destW * page.img.picture.height) / page.img.picture.width;
      canvas.style.width = destW + "px";
      canvas.style.height = destH + "px";

      destW *= pxr;
      destH *= pxr;
      canvas.width = destW;
      canvas.height = destH;
      // ctx.drawImage(page.img.picture, 0, -yMinus, destW, destH);
      const quality = "medium"; //window.chrome ? "medium" : "high"; // med for chr engine because their bug :-(

      canvas.getContext("2d").imageSmoothingQuality = quality;
      ctx.drawImage(page.img.picture, 0, 0, destW, destH);

      if (this.page.searchHighlights) {
        let fsDraw = this.getCanvasCoords(
          page.img.picture.width,
          page.img.picture.height,
          this.page.searchHighlights,
          canvas,
          page.img.imageMetaData.PDF
        );
        ctx.globalCompositeOperation = "multiply";
        fsDraw.forEach((fs, i) => {
          ctx.fillStyle = `rgba(255,255,102)`;
          ctx.fillRect(fs.x - 3, fs.y - 3, fs.w + 6, fs.h + 6);
        });
      }
      if (!this.mask) return;

      /** @type HTMLCanvasElement */
      const canvasMask = new OffscreenCanvas(100, 100);
      const ctxMask = canvasMask.getContext("2d");
      canvasMask.width = canvas.width;
      canvasMask.height = canvas.height;
      ctxMask.fillStyle = "rgba(255,255,255,0.7)";
      ctxMask.fillRect(0, 0, canvasMask.width, canvasMask.height);

      for (const col in page.columns) {
        const column = page.columns[col];
        for (const rects of column.marks) {
          //convert to px
          let xw = canvas.width;
          let xh = canvas.height;
          const x = rects.x * xw;
          const y = rects.y * xh;
          const h = rects.h * xh;
          const w = rects.w * xw;

          //   ctx.fillStyle = "rgba(0,0,0,0.05)";
          //   ctx.fillRect(x, y, w, h);

          ctxMask.clearRect(x, y, w, h);
        }
      }
      ctx.drawImage(canvasMask, 0, -yMinus);
      this.$nextTick(() => {
        canvas.style.width = "100%";
        canvas.style.height = "auto";
      });
    },
    getCanvasCoords(imgWidth, imgHeight, coords, img, webP) {
      try {
        let ratio = 1;
        let rat2 = img.width / imgWidth;
        if (webP) {
          ratio = imgWidth / 3000;
        }
        let _this = this;
        return coords.map((coord) => ({
          x: parseInt(coord.left * ratio * rat2), // * (_this.actualW / imW)) + _this.paddingLeft,
          y: parseInt(coord.top * ratio) * rat2, // * (_this.actualH / imH)),
          w: parseInt(coord.width * ratio * rat2), // * (_this.actualW / imW)),
          h: parseInt(coord.height * ratio * rat2), //* (_this.actualH / imH)),
        }));
      } catch (ex) {
        console.log(ex);
        return [];
      }
    },
  },
  watch: {
    mask: function (val, oldV) {
      this.drawCanvas();
    },
  },
};
</script>

<style lang="scss" scoped>
.div-padd {
  padding: 8px;
}
</style>
